import { Injectable } from '@angular/core';
import { ApiClientService } from 'src/app/@core/services/api-client.service';
import { BaseFucntionsService } from 'src/app/@core/services/base-functions.service';
import { UserModel, UserProfileModel } from '../models/user.model';
import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';

@Injectable({
  providedIn: 'root',
})

export class UserService extends BaseFucntionsService<UserModel> {

  constructor(apiClient: ApiClientService) {
    super(ApplicationRoutes.Users.UsersController, apiClient);
  }

  SocialStatus() {
    return [
      { id: 0, name: 'Single' },
      { id: 1, name: 'Married' },
      { id: 2, name: 'Widower' },
      { id: 3, name: 'Divorced' },
    ];
  }

  getInstructors() {
    return this.apiClient.get(ApplicationRoutes.Users.InstructorsDropDown);
  }
  
  getTrainees() {
    return this.apiClient.get(ApplicationRoutes.Users.TraineesDropDown);
  }

  /** Instructors flagged "show in home"; public projection without personal data. */
  getHomeInstructors() {
    return this.apiClient.get(ApplicationRoutes.Users.HomeInstructors);
  }

  getInstructorProfileDetails(userId: number) {
    return this.apiClient.get(ApplicationRoutes.Users.InstructorProfile(userId));
  }
  getUserProfileDetails(userId: number) {
    return this.apiClient.get(ApplicationRoutes.Users.UserProfile(userId));
  }
  updateUserProfile(data: UserProfileModel , userId: number) {
    return this.apiClient.update(ApplicationRoutes.Users.UserProfile(userId), data);
  }
  getCenters() {
    return this.apiClient.get(ApplicationRoutes.Users.TrainingCentersDropDown);
  }

  getUserFirebaseToken() {
    return this.apiClient.get(ApplicationRoutes.Users.FirebaseToken);
  }

  changeFirebaseToken(token: string) {
    return this.apiClient.get(ApplicationRoutes.Users.FirebaseToken);
  }

  getUserJobDetails(userId: number = null) {
    let query = userId ? `?userId=${userId}` : '';
    return this.apiClient.get(`${ApplicationRoutes.Users.Job.Controller}${query}`);
  }

  checkIfActiveDirectoryUser(){
    return this.apiClient.get(ApplicationRoutes.Users.CheckActiveDirectoryUser);
  }
  public getJobDropDown(parentOnly: boolean = false) {
    return this.apiClient.get(`${ApplicationRoutes.Users.Job.JobDropDown}?parentOnly=${parentOnly}`);
  }

  public getSkillsDropDown() {
    return this.apiClient.get(`${ApplicationRoutes.Users.Job.SkillsDropDown}`);
  }

  public jobDetails(id: number) {
    return this.apiClient.get(`${ApplicationRoutes.Users.Job.Details(id)}`);
  }


}
